/**
 * Helpers for creating UserOffices instance
 */

import type { IBaseNotary } from "../../BaseNotaryFactory";
import type { UserOfficeAffiliation } from "le-coffre-resources/dist/Notary";
import {
	createGetUserOfficesMethod,
	createSetActiveOfficeMethod,
	createGetActiveOfficeMethod,
	createSyncUserOfficesMethod,
} from "./userOfficesMethodsHelpers";

export interface UserOfficesInstance {
	getUserOffices(userUid: string): Promise<UserOfficeAffiliation[]>;
	setActiveOffice(
		userUid: string,
		officeUid: string,
		menuOfficeUidForGuestJwt?: string | null,
	): Promise<{ message: string; office_uid: string; accessToken?: string; refreshToken?: string }>;
	getActiveOffice(userUid: string): Promise<UserOfficeAffiliation>;
	syncUserOffices(userUid: string): Promise<UserOfficeAffiliation[]>;
}

/**
 * Create UserOffices instance with all methods
 */
export function createUserOfficesInstance(baseNotary: IBaseNotary): UserOfficesInstance {
	const usersUrl = baseNotary.namespaceUrl.concat("/users");

	return {
		getUserOffices: createGetUserOfficesMethod(baseNotary, usersUrl),
		setActiveOffice: createSetActiveOfficeMethod(baseNotary, usersUrl),
		getActiveOffice: createGetActiveOfficeMethod(baseNotary, usersUrl),
		syncUserOffices: createSyncUserOfficesMethod(baseNotary),
	};
}
